import { render, staticRenderFns } from "./CarShopEditor.vue?vue&type=template&id=51ed52a8&scoped=true"
import script from "./CarShopEditor.vue?vue&type=script&lang=ts"
export * from "./CarShopEditor.vue?vue&type=script&lang=ts"
import style0 from "./CarShopEditor.vue?vue&type=style&index=0&id=51ed52a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed52a8",
  null
  
)

export default component.exports